import { Component, Host, h, Prop, JSX } from '@stencil/core'

@Component({
    tag: 'zr-badge',
    styleUrl: 'zr-badge.scss',
    shadow: true,
})

/**
 * ZrBadge component.
 */
export class ZrBadge {
    /**
     * This defines if the best before badge should be visible.
     */
    @Prop() hasBestBeforeBadge = false

    /**
     * This defines best before badge heading.
     */
    @Prop() bestBeforeBadgeHeading = 'Kurzes MHD'

    /**
     * This defines if the b stock badge should be visible.
     */
    @Prop() hasBStockBadge = false

    /**
     * This defines the b stock badge heading.
     */
    @Prop() bStockBadgeHeading = 'Rückläufer'

    /**
     * This defines if the discount badge should be visible.
     */
    @Prop() hasDiscountBadge = false

    /**
     * This defines the discount percentage.
     */
    @Prop() discount = 0

    /**
     * This defines if the sponsor badge should be visible.
     */
    @Prop() hasSponsorBadge = false

    /**
     * This defines the sponsor badge heading.
     */
    @Prop() sponsorBadgeHeading = 'Gesponsert'

    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render(): JSX.Element {
        return (
            <Host>
                {this.hasSponsorBadge &&
                    <div class="zr-badge--sponsor">
                        <span>{this.sponsorBadgeHeading}</span>
                    </div>
                }
                {this.hasBestBeforeBadge &&
                    <div class="zr-badge--mhd">
                        <span>{this.bestBeforeBadgeHeading}</span>
                    </div>
                }
                {this.hasBStockBadge &&
                    <div class="zr-badge--b-stock">
                        <span>{this.bStockBadgeHeading}</span>
                    </div>
                }
                {this.hasDiscountBadge &&
                    <div class="zr-badge--discount">
                        <span>{'- ' + Math.round(this.discount) + ' %'}</span>
                    </div>
                }
            </Host>
        )
    }
}
